import { Component,  Input, OnInit } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../base-component/base.component';
import { ReceiverAPI } from '../../../receivers/services/receiver-api.service';
import { requiredKeys } from '@shared/validators/required-keys.validator';
import { preventDuplication } from '@shared/validators/prevent-duplication.validator';
import { UserApi } from '../../services';
import { Receiver } from '@features/receivers/models/receiver.model';

@Component({
  selector: 'app-permit-access-control-list',
  templateUrl: './permit-access-control-list.component.html',
  styleUrls: ['./permit-access-control-list.component.scss']
})
export class PermitAccessControlListComponent extends BaseComponent implements OnInit {
  @Input() formArray: FormArray;
  receivers: Receiver[];

  validatorsPerControl: {[k: number]: boolean} = {};

  constructor(

    private receiverApiService: ReceiverAPI,
    private userApiService: UserApi,
  ) {
    super();
  }

  ngOnInit(): void {
    this.load(
      this.receiverApiService.getAllReceivers(this.userApiService.currentUser$.value.parentId),
    ).subscribe((receivers) => {
      this.receivers = receivers;
    });

    if (!this.formArray.controls?.length) {
      this.addAnotherControl();
    }
  }

  addAnotherControl(): void {
    const validators = [
      requiredKeys(['receiver', 'expirationDate', 'label']),
      preventDuplication(this.formArray, this.formArray.controls.length, ['receiver', 'expirationDate']),
    ];

    const control = new FormControl({ label: null, receiver: null, expirationDate: null }, []);
    const controlIndex = this.formArray.controls.length;

    control.valueChanges.pipe(
      takeUntil(this.destroy$),
    ).subscribe(() => {
      const hasValue = Object.keys(control.value).some(key => control.value[key] !== null && typeof control.value[key] !== 'undefined');
      if (hasValue && !this.validatorsPerControl[controlIndex]) {
        control.setValidators(validators);
        this.validatorsPerControl[controlIndex] = true;
        control.updateValueAndValidity();
      } else if (this.validatorsPerControl[controlIndex]) {
        control.setValidators([]);
        this.validatorsPerControl[controlIndex] = false;
        // control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    });

    this.formArray.push(control);
    this.formArray.updateValueAndValidity();
  }

  removeControl(index: number): void {
    this.formArray.removeAt(index);
    this.formArray.updateValueAndValidity();
    this.validatorsPerControl[index] = false;
  }
}
